import type { RowData } from "@tanstack/react-table";
import { closestCenter, DndContext, type DragEndEvent, type SensorDescriptor, type SensorOptions } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { TableRowList, type TableRowListProps } from "./TableRowList";

export interface TableBodyReorder {
  sensors: SensorDescriptor<SensorOptions>[];
  onDragEnd: (event: DragEndEvent) => void;
  ids: string[];
}

export interface TableBodyProps<TRow extends RowData> extends TableRowListProps<TRow> {
  reorder: TableBodyReorder | undefined;
}

export const TableBody = <TRow extends RowData>({ reorder, ...listProps }: TableBodyProps<TRow>) => {
  if (!reorder) return <TableRowList {...listProps} />;

  return (
    <DndContext sensors={reorder.sensors} collisionDetection={closestCenter} onDragEnd={reorder.onDragEnd}>
      <SortableContext items={reorder.ids} strategy={verticalListSortingStrategy}>
        <TableRowList {...listProps} />
      </SortableContext>
    </DndContext>
  );
};
